import { render } from "./Project3Dto2D.vue?vue&type=template&id=b0d4e7c4"
import script from "./Project3Dto2D.vue?vue&type=script&lang=js"
export * from "./Project3Dto2D.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__